import { UserData } from "../Models/userData";
import { DataService } from "../Services/dataService";
import { FirebaseService } from "../Services/firebaseService";

export class ConnexionPage {

    accountPageURL = "/formation";

    pageElement: HTMLElement = document.querySelector('.connection') as HTMLElement;
    loginElement: HTMLInputElement = document.getElementById('email') as HTMLInputElement;
    passwordElement: HTMLInputElement = document.getElementById('password') as HTMLInputElement;
    submitElement: HTMLButtonElement = document.getElementById('submitbutton') as HTMLButtonElement;
    errorElement: HTMLElement = document.getElementById('error') as HTMLElement;

    loaderElement: HTMLElement = document.querySelector('.loader') as HTMLElement;

    dataService: DataService;
    firebaseService: FirebaseService;

    constructor() {
        this.dataService = new DataService();
        this.firebaseService = new FirebaseService();

        this.submitElement.addEventListener('click', (event: any) => {
            event.preventDefault();
            event.stopPropagation();
            this.login()
        });
        this.loader(false)

    }

    async login() {

        let email = this.loginElement.value.toLowerCase().trim();
        let password = this.passwordElement.value;

        this.loader(true);

        let user: UserData = await this.dataService.getUser(email);
        console.log('auth', email, password);
        if (user && user.paymentStatus == "paid") {
            try {
                console.log('try auth');
                let firebaseUser = await this.firebaseService.loginWithEmail(email, password);
                this.redirectUser();
                return;
            }
            catch (error: any) {
                console.log(error);
                if (error.code === "auth/user-not-found") {
                    try {
                        console.log('create user');
                        let firebaseUser = await this.firebaseService.createAccount(email, password);
                        this.redirectUser();
                        return;
                    } catch (signupError: any) {
                        this.showError('Impossible de vous connecter !');
                    }
                }
                else
                {
                    this.showError("Impossible de vous connecter !");
                }
                
            }

        }
        else {
            this.showError('Impossible de vous connecter !');
        }
        this.loader(false);

    }

    redirectUser()
    {
        window.location.href = this.accountPageURL;
    }

    showError(error: string) {
        this.errorElement.style.display = 'block';
        this.errorElement.innerHTML = error;
    }

    loader(show: boolean) {
        this.loaderElement.style.display = show ? 'block' : 'none';
        this.pageElement.style.display = !show ? 'block' : 'none';
    }
}